import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginModule } from './login/login.module';
import { ErrorModule } from './error/error.module';
import {AngularMaterialModules, CaptchaModule, SharedModule} from './shared/shared.module';
import { Principal } from './shared/auth/principal.service';
import { AccountService } from './shared/auth/account.service';
import { AuthServerProvider } from './shared/auth/auth-jwt.service';
import { StateStorageService } from './shared/auth/state-storage.service';
import { DataStorageService } from './shared/data-storage.service';
import { UserRouteAccessService } from './shared/auth/user-route-access-service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AuthInterceptor } from './blocks/interceptor';
import { GenInfoComponent } from './payment/gen-info/gen-info.component';
import { ServicesComponent } from './payment/services/services.component';
import { GenAdsComponent } from './payment/gen-ads/gen-ads.component';
import { PaymentService } from './payment/Payment.Services';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { HomeComponent } from './home/home.component';
import { UserRegiBillerComponent } from './user-regi-biller/user-regi-biller.component';
import { UserService } from './user/user.service';
import { AboutUsComponent } from './about-us/about-us.component';
import { InfoComponent } from './info/info.component';
import { InfoService } from './info/info-service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '../../node_modules/@angular/common/http';
import { LoggerModule, NgxLoggerLevel } from '../../node_modules/ngx-logger';
import { TranslateModule, TranslateLoader } from '../../node_modules/@ngx-translate/core';
import { HttpModule } from '@angular/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule, MatInputModule} from '@angular/material';
import {CoronaDialog} from "./home/corona.component";
import {DonationComponent} from "./donation/donation-info/donation.component";
import {DonationService} from "./payment/Donation.Services";
import {DonationSuccessComponent} from "./donation/donatio-return-url/donation-success.component";
import {DonationCancelComponent} from "./donation/donatio-return-url/donation-cancel.component";
import {DonationFailComponent} from "./donation/donatio-return-url/donation-fail.component";
import { PrivacyComponent } from './privacy/privacy.component';
import {NewPaymentUiComponent} from "./new-payment-ui/new-payment-ui.component";
import { HomePageComponent } from './payment/home-page/home-page.component';
import { ServiceLinkService } from './payment/service-links/service-links-service';
import { GalleryComponent } from './gallery/gallery.component';
import { PartnersComponent } from './partners/partners.component';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    UserRegiBillerComponent,
    GenInfoComponent,
    ServicesComponent,
    GenAdsComponent,
    HomeComponent,
    AboutUsComponent,
    InfoComponent,
    CoronaDialog,
    DonationComponent,
    DonationSuccessComponent,
    DonationCancelComponent,
    DonationFailComponent,
    PrivacyComponent,
    NewPaymentUiComponent,
    HomePageComponent,
    GalleryComponent,
    PartnersComponent

  ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        HttpModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LoginModule,
        SharedModule,
        CaptchaModule,
        ErrorModule,
        TranslateModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        LoggerModule.forRoot({level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR}),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        }),
        AngularMaterialModules,

    ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    Principal,
    AccountService,
    AuthServerProvider,
    LocalStorageService,
    SessionStorageService,
    StateStorageService,
    DataStorageService,
    UserRouteAccessService,
    PaymentService,
    UserService,
    InfoService,
    DonationService,
    ServiceLinkService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent],
  entryComponents: [CoronaDialog]

})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts